// src/services/company/forms/formServices.js
import api from "services/api";

// Get all forms for current company
export const getForms = async () => {
  return api.get("/v1/api/forms/list");
};

// Get form details with its dynamic fields
export const getFormDetails = async (formId) => {
  return api.get(`/v1/api/forms/${formId}`);
};

// Create a new dynamic form
export const createForm = async (formData) => {
  return api.post("/v1/api/forms/create", formData);
};

// Update an existing dynamic form
export const updateForm = async (formId, formData) => {
  return api.put(`/v1/api/forms/${formId}`, formData);
};

// Delete a form
export const deleteForm = async (formId) => {
  return api.delete(`/v1/api/forms/${formId}`);
};
